import {
  pathAssetsGlobal,
  pathAssets,
  pathAssetsJavelin
} from '@/globals/globalvariables'
import type { LoaderDataTypes } from '@powerplay/core-minigames'
import { TexturesNames } from '../types'

// Hlavny priecinok s texturami
const texturesDir = `${pathAssets}/textures/` // TODO: nemali by sme brat veci zo 100m, ale malo by to ist cez global
const texturesDirJavelin = `${pathAssetsJavelin}/textures/`
const texturesDirGlobal = `${pathAssetsGlobal}/textures/`

/**
 * Konfig pre textury
 */
export const texturesConfig: LoaderDataTypes = {
  [TexturesNames.athleteRaceWhiteMan]: {
    ext: 'ktx2',
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.athleteRaceMulattoMan]: {
    ext: 'ktx2',
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.athleteRaceBlackMan]: {
    ext: 'ktx2',
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.athleteRaceWhiteWoman]: {
    ext: 'ktx2',
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.athleteRaceMulattoWoman]: {
    ext: 'ktx2',
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.athleteRaceBlackWoman]: {
    ext: 'ktx2',
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.athleteClothes]: {
    ext: 'ktx2',
    genderActive: true,
    version: 241120,
    femaleVersion: 241120,
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.athleteHairMan]: {
    ext: 'ktx2',
    version: 2,
    dir: `${texturesDir}/athlete/`
  },
  [TexturesNames.athleteHairWoman]: {
    ext: 'ktx2',
    version: 20230927,
    dir: `${texturesDir}/athlete/`
  },
  [TexturesNames.javelin]: {
    ext: 'ktx2',
    version: 241104,
    dir: `${texturesDirJavelin}/athlete/`
  },
  [TexturesNames.audience]: {
    ext: 'ktx2',
    version: 2,
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.colorGradient]: {
    ext: 'ktx2',
    version: 2,
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.colorGradientVshosting]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.concrete]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.glassPanel]: {
    ext: 'ktx2',
    dir: `${texturesDir}/env/`
  },
  [TexturesNames.grass]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.hexCladding]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.metal]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.panel]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.sand]: {
    ext: 'ktx2',
    dir: `${texturesDir}/env/`
  },
  [TexturesNames.seats]: {
    ext: 'ktx2',
    version: 2,
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.stairs]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.lattice]: {
    ext: 'ktx2',
    dir: `${texturesDir}/env/`
  },
  [TexturesNames.emissive]: {
    ext: 'ktx2',
    dir: `${texturesDir}/env/`
  },
  [TexturesNames.flagsImages]: {
    ext: 'ktx2',
    version: 240610,
    dir: `${texturesDir}/env/`
  },
  [TexturesNames.gradient]: {
    ext: 'ktx2',
    dir: `${texturesDir}/env/`
  },
  [TexturesNames.npc]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.lightFlashes]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.numbers]: {
    ext: 'ktx2',
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.skybox]: {
    ext: 'ktx2',
    version: 241016,
    dir: `${texturesDirGlobal}/env/`
  },
  [TexturesNames.envLightmap]: {
    ext: 'ktx2',
    dir: `${texturesDirJavelin}/env/`,
    version: 241120,
    returnTextureLightmap: true
  },

}
